import { Box } from '@mui/material';
import React from 'react';
import { MINI_BUTTON_ACTION_SIZE, MINI_BUTTON_DOCK_GAP, miniButtonDockBottomInset } from '../helpers/liquidGlassSurface';
import { MainActionButton, type MainActionButtonProps } from './MainActionButton';
import { SecondaryActionButton, type SecondaryActionButtonProps } from './SecondaryActionButton';

const bottomUiInset = `calc(${MINI_BUTTON_DOCK_GAP}px + ${miniButtonDockBottomInset})`;

export interface ButtonDockProps {
    main?: MainActionButtonProps;
    secondary?: SecondaryActionButtonProps;
}

export const ButtonDock: React.FC<ButtonDockProps> = ({ main, secondary }) => {
    const mainVisible = !!main;
    const secondaryVisible = !!secondary;
    const containerVisible = mainVisible || secondaryVisible;
    const bothButtonsVisible = mainVisible && secondaryVisible;
    const mainNavigation = main?.navigation ?? (/^(back|close)$/i.test(main?.text.trim() ?? '') ? 'back' : undefined);

    if (!containerVisible) {
        return null;
    }

    return (
        <Box
            sx={{
                flexShrink: 0,
                width: '100%',
                boxSizing: 'border-box',
                bgcolor: 'transparent',
                pb: bottomUiInset,
                pt: `${MINI_BUTTON_DOCK_GAP}px`,
                pointerEvents: 'none',
                '& button, & [role="button"]': {
                    pointerEvents: 'auto',
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: bothButtonsVisible
                        ? 'space-between'
                        : secondaryVisible || mainNavigation
                          ? 'flex-start'
                          : 'flex-end',
                    gap: `${MINI_BUTTON_DOCK_GAP}px`,
                    width: '100%',
                    boxSizing: 'border-box',
                    px: `${MINI_BUTTON_DOCK_GAP}px`,
                    minHeight: MINI_BUTTON_ACTION_SIZE,
                }}
            >
                {secondary && <SecondaryActionButton {...secondary} />}
                {main && <MainActionButton {...main} $fullWidth={!bothButtonsVisible && !secondaryVisible} />}
            </Box>
        </Box>
    );
};
